<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Add New Delivery Agent</strong>           
          </div>
          <div class="box">
                       <!--  <div id="adduser"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1"> -->
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
               <!-- <input type="hidden" name="chkEditVal" id="chkEditVal" value="0"> -->
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-form-input type="text" name="first name" v-model="customer.deliveryagentfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.first name') }" placeholder="Enter First Name">                       
                       </b-form-input>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('first name')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.first name')" class="help text-danger">{{ errors.first('form-1.first name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Last Name</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="last name" v-model="customer.deliveryagentlastname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.last name') }" placeholder="Enter Last Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('last name')" ></i>
                      </span>
                         <span style="width:240px" v-show="errors.has('form-1.last name')" class="help text-danger">{{ errors.first('form-1.last name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="addmobilenumber">Mobile Number</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="addmobilenumber" name="mobile number" maxlength="10" v-model="customer.deliveryagentmobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.mobile number') }" placeholder="Enter Mobile Number" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobile number')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.mobile number')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-1.mobile number') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="addaltenatemobilenumber">Alternate Mobile Number</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="addaltenatemobilenumber" name="alternate_mobile number" maxlength="10" v-model="customer.deliveryagentaltmobilenumber"  v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.alternate_mobile number') }" placeholder="Enter Alternate Mobile Number" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3" >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('alternate_mobile number')" ></i>
                      </span>
                      <code  v-show="errors.has('form-1.alternate_mobile number')" id="addaltmblnbrmsg" class="help text-danger">{{ errors.first('form-1.alternate_mobile number') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                
                  <b-col sm="3">
                    <b-form-group>
                      <label for="password">Password</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="password" name="password" minlength="6" maxlength="14" v-model="customer.password" v-validate="'required|min:6|max:14'" :class="{'input': true, 'text-danger': errors.has('form-1.password') }" placeholder="Enter Password">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('password')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.password')" id="passwordtxt" class="help text-danger">{{ errors.first('form-1.password') }}
                      </code>                      
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                   <b-col sm="3">
                    <b-form-group>
                      <label for="vehicleprefix">Vehicle Prefix</label>
                      <b-input-group class="mb-3">
                         <!-- <input class="input" type="hidden"   name="prefix" id="vehicleprefix" maxlength="1" v-validate="'required|char:1'" :class="{'input': true, 'text-danger': errors.has('form-1.prefix') }" placeholder="Enter Vehicle Prefix"> -->
                       
                        <b-form-input class="input" type="text" v-model="customer.vehicleprefix" name="vehicleprefix" id="vehicleprefix"   v-validate="{  regex: /^[A-Z]*$/, max: 1, }" maxlength="1"  :class="{'input': true, 'text-danger': errors.has('form-1.vehicleprefix') }" placeholder="Enter Vehicle Prefix">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.vehicleprefix')" class="help text-danger">{{ errors.first('form-1.vehicleprefix') }} Please enter Capital letter only</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="vehicleno ">Vehicle Number</label>
                      <b-input-group class="mb-3">
                        <!--  <input class="input" type="hidden" name="pincode" id="deliveryagentpincodedev" maxlength="6" v-validate="'required|digits:6'" :class="{'input': true, 'text-danger': errors.has('form-1.pincode') }" placeholder="Enter Location ID"> -->
                       
                        <b-form-input class="input" type="text" v-model="customer.vehicleno" name="vehicleno" id="vehicleno" maxlength="6" v-validate="'required|numeric'" :class="{'input': true, 'text-danger': errors.has('form-1.vehicleno') }" placeholder="Enter Vehicle Number">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.vehicleno')" class="help text-danger">{{ errors.first('form-1.vehicleno') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="local">Vehicle Local</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.local" v-on:change="setcountry" name="local" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.local') }">
                          <option value="">--Select--</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </b-form-select>
                        </b-input-group>
                       <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('local')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.local')" id="statustxt" class="help text-danger">{{ errors.first('form-1.local') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                 
                  <b-col sm="3">
                    <b-form-group>
                      <label for="vehiclecountry">Vehicle Country</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-model="customer.vehiclecountry" name="vehiclecountry" id="vehiclecountry" v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-1.vehiclecountry') }" placeholder="Enter Vehicle Country">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.vehiclecountry')" class="help text-danger">{{ errors.first('form-1.vehiclecountry') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                   <b-col sm="3">
                    <b-form-group>
                      <label for="vehiclecity">Vehicle City</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-model="customer.vehiclecity" name="vehiclecity" id="vehiclecity" v-validate="{ required: true, regex: /^[A-Za-z\s\-]+$/
 }" :class="{'input': true, 'text-danger': errors.has('form-1.vehiclecity') }" placeholder="Enter Vehicle City">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.vehiclecity')" class="help text-danger">{{ errors.first('form-1.vehiclecity') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <!-- <b-col sm="3">
                      <b-form-group>
                        <label for="local">Local</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.local" name="local" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.local') }">
                          <option value="">--Select--</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </b-form-select>
                        </b-input-group>
                       <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('local')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.local')" id="statustxt" class="help text-danger">{{ errors.first('form-1.local') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col> -->
                  <b-col sm="3">
                    <b-form-group>
                      <label for="drivinglicense">Driving License</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-model="customer.drivinglicense" name="drivinglicense" id="drivinglicense" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.drivinglicense') }" placeholder="Enter Driving License">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.drivinglicense')" class="help text-danger">{{ errors.first('form-1.drivinglicense') }} 'Please enter letters only'</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="drivercontractername">Driver Contracter Name</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-model="customer.drivercontractername" name="drivercontractername" id="drivercontractername" v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-1.drivercontractername') }" placeholder="Enter Driver Contracter Name">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.drivercontractername')" class="help text-danger">{{ errors.first('form-1.drivercontractername') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="contracteremail">Contracter Email</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-model="customer.contracteremail" name="contracteremail" id="contracteremail" v-validate="'required|email'" :class="{'input': true, 'text-danger': errors.has('form-1.contracteremail') }" placeholder="Enter Contracter Email">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.contracteremail')" class="help text-danger">{{ errors.first('form-1.contracteremail') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="isdummy">Is Dummy</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isdummy" name="isdummy" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.isdummy') }">
                          <option value="">--Select--</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('isdummy')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.isdummy')" id="statustxt" class="help text-danger">{{ errors.first('form-1.isdummy') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="pincode">Status</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.status')" id="statustxt" class="help text-danger">{{ errors.first('form-1.status') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="editusertype">User Type</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.editusertype" name="editusertype" :class="{'input': true, 'is-invalid': errors.has('form-1.editusertype') }">
                          <option value="0">--Select--</option>
<!--                           <option value="1">SDD</option>
                          <option value="2">NDD</option> -->
                          <option value="3">Try & Buy</option>
                          <option value="4">First Mile</option>


                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('editusertype')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.editusertype')" id="statustxt" class="help text-danger">{{ errors.first('form-1.editusertype') }}
                        </code>
                        </b-input-group>
                      
                      </b-form-group>
                 </b-col>
              <!-- <b-row class="form-group" > -->
                <b-col sm="3" v-if="customer.editusertype === '4'">
                      <b-form-group>
                        <label for="editfmridertype">FM Rider Type</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.editfmridertype" name="editfmridertype" :class="{'input': true, 'is-invalid': errors.has('form-1.editfmridertype') }">
                          <option value="">--Select--</option>
                          <option value="0">Normal FM Rider </option>
                          <option value="1">Relieving FM Rider</option>


                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('editfmridertype')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.editfmridertype')" id="statustxt" class="help text-danger">{{ errors.first('form-1.editfmridertype') }}
                        </code>
                        </b-input-group>
                      
                      </b-form-group>
                  </b-col>
                <!-- </b-row> -->

                  <b-col sm="3">
                      <b-form-group>
                        <label for="isverified ">Is Verified</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isverified" name="isverified" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.isverified') }">
                          <option value="">--Select--</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('local')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.isverified')" id="isverified" class="help text-danger">{{ errors.first('form-1.isverified') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                   <b-col sm="3">
                      <b-form-group>
                        <label for="isprivilage ">Is Privilage Rider</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isprivilage" name="isprivilage" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.isprivilage') }">
                          <option value="">--Select--</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('local')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.isprivilage')" id="isprivilage" class="help text-danger">{{ errors.first('form-1.isprivilage') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>

                   <!-- IsIVR Latest code -->
                     <b-col sm="3">
                      <b-form-group v-if="user_id === 124 || user_id === 61">
                        <label for="isIVR">Is IVR Rider</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="isIVR" name="isIVR" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.isIVR') }">
                          <option :value="selected">--Select--</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('isIVR')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.isIVR')" id="statustxt" class="help text-danger">{{ errors.first('form-1.isIVR') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                        <b-form-group v-else>
                        <label for="isIVR">Is IVR Rider</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="isIVR" name="isIVR" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.isIVR') }">
                          
                          <option value="1">Yes</option>
                         
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('isIVR')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.isIVR')" id="statustxt" class="help text-danger">{{ errors.first('form-1.isIVR') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                  <!-- IsIVR end -->
                  <!-- SDD/NDD FLAG Code -->
                    <b-col sm="3">
                      <b-form-group>
                        <label for="RiderFlag">SDD/NDD Rider</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.RiderFlag" name="RiderFlag" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.RiderFlag') }">
                          <option value="">--Select--</option>
                          <option value="SDD">SDD</option>
                          <option value="NDD">NDD</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('RiderFlag')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.RiderFlag')" id="statustxt" class="help text-danger">{{ errors.first('form-1.RiderFlag') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                   <!-- SDD/NDD FLAG Code End -->
                  <!-- Hub to Hub -->
                   <b-col sm="3">
                      <b-form-group v-if="userCountry == 'KSA'">
                        <label for="RiderFlag">Is HubToHub</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.hubtohub" name="hubtohub" >
                          <option value="">--Select--</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </b-form-select>
                        </b-input-group>
                   
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="fuelcount">Fuel in Liter</label>
                      <b-input-group class="mb-3">
                        <b-form-input 
                        class="input" type="text" minlength="1" maxlength="3" v-model="customer.fuel_allowance" name="fuel"  v-validate="'numeric|max:3|greaterThanZero'" placeholder="Enter Fuel in Liter">
                        </b-form-input> 
                      </b-input-group>
                   
                    </b-form-group>
                </b-col>
                  <!-- end -->
                </b-row>
                <div id="overlay" >
             <div class="loader"></div>
           </div>
           
                <footer class="column has-text-right">
                <b-button variant="primary" size="md" type="submit" >Save</b-button>&nbsp;
                <b-button variant="primary" size="md" type="submit" @click="$router.push('/qwik_deliveryagentmastermr/quick_dashboard')">Cancel</b-button>
                </footer>
              </b-form>
            <!-- </div> -->
          </div>
       
       </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<style>  
.scroll {  
    width: 200px;  
    height: 100px;  
    overflow: scroll;  
}  
</style> 
<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth"
import Router from 'vue-router'
export default {

  data: function() {
    return {
      name: 'reattemptshipment',
      customer: {},
      deliveryagentfirstname: '',
      alternatenumbermsg:'',
      user_id:0,
      isIVR:"1",
      selected:"",

     
    }
  },
  created: function() {
   var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
    this.user_id = userInfo.sysusermasterid;
    this.userCountry = userInfo.country;
    // console.log("Country",this.userCountry);
    // this.customer.hubtohub="No";

    this.$validator.extend(
      'greaterThanZero',{
      getMessage: field =>  field + ' needs to be > zero.',
      validate: (value) => {
        // value must be > zero
        if (value > 0 ) return true;
        return false;
      }
      });

  },
  methods: {
 
  validateForm(scope) {
    
    
      this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addAgentInfo();
        }
      });
    },
     setcountry: function(event) {
      
      // console.log(event);
      if(event=="Yes")
      {
       this.customer.vehiclecountry="United Arab Emirates" 
      }
      else
       {
        this.customer.vehiclecountry=""
       } 
    },

     chkmobileVal() {
      var chkValidate = true;
     // var chknumb = /^[0789]{1}\d{9}$/;
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

      var mobilenumber = document.getElementById("addmobilenumber").value;
      if (
        mobilenumber.trim() === "0000000000" ||
        mobilenumber.trim().length < 10
      ) {
        chkValidate = false;
        return false;
      } else if (
        mobilenumber.trim() != "" &&
        !mobilenumber.trim().match(chknumb)
      ) {
        chkValidate = false;
        return false;
      }
      return (chkValidate = chkValidate);
    },

    addAgentInfo: function() {

      var chkmobileVal = this.chkmobileVal();
      if (chkmobileVal) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var vehicleno1=this.customer.vehicleprefix+' '+this.customer.vehicleno
        
         var editusertype='0';
         var editfmridertype='';
      
       if(this.customer.editusertype){
        editusertype=this.customer.editusertype;
      }
       if(this.customer.editfmridertype){
        editfmridertype=this.customer.editfmridertype;
      }

      if(this.customer.vehicleprefix == undefined||this.customer.vehicleprefix == null ||this.customer.vehicleprefix == '')
      {
        var vehicleno1=this.customer.vehicleno
      }
      else
      {
         var vehicleno1=this.customer.vehicleprefix+' '+this.customer.vehicleno
       
      }
      if(this.customer.deliveryagentaltmobilenumber != this.customer.deliveryagentmobilenumber){
        var alternatenumber=this.customer.deliveryagentaltmobilenumber
      }
      else{
         this.$fire({
                  text: "Alternate_Mobile Number should be different from Mobile Numbe",
                  type: "warning",
                  timer: 30000
                }); 
        // alternatenumbermsg="Alternate Number Same as Mobile Number";
        return false;
      }

      if(this.userCountry != 'KSA'){
          if(editusertype=='3'){
            document.getElementById("overlay").style.display = "block";
            const agnetsave = {
                  usertype:editusertype,
                  deliveryagentfirstname:this.customer.deliveryagentfirstname,
                  deliveryagentlastname:this.customer.deliveryagentlastname,
                  deliveryagentmobilenumber:this.customer.deliveryagentmobilenumber,
                  deliveryagentaltmobilenumber:this.customer.deliveryagentaltmobilenumber,
                  password:this.customer.password,
                  vehicleno:vehicleno1 ,
                  isactive:this.customer.isactive,
                  isverified:this.customer.isverified,
                  privilege_rider:this.customer.isprivilage,
                  lastmodifiedby:`${userInfo.sysemailid}`,
                  deliveryagentpincode:`${userInfo.pickuplocationpincode}`,
                  local:this.customer.local,
                  vehicleno_prefix:this.customer.vehicleprefix,
                  vehicle_country:this.customer.vehiclecountry,
                  vehicle_city:this.customer.vehiclecity,
                  driving_license:this.customer.drivinglicense,
                  contracter_emailid:this.customer.contracteremail,
                  driver_contracter_name:this.customer.drivercontractername,
                  is_dummy:this.customer.isdummy,
                  ivr_rider:this.isIVR,
                  is_sdd_ndd:this.customer.RiderFlag,
                  hub_to_hub_delivery:'No',
                  fuel_allowance : this.customer.fuel_allowance,
                  is_qwik_user: `${userInfo.is_qwik_user}`
                  
                }
                      console.log("agnetsave",agnetsave)
              // return false
              this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentsignuphub`,agnetsave)
                .then(result => {
              // console.log(result);
              document.getElementById("overlay").style.display = "none";
                  if (result.body[0].returnmsg === "Successful") {
                    this.$fire({
                      text: "Added successfully",
                      type: "success",
                      timer: 30000
                    }); 
                    this.customer = {};
                    this.$router.push('/qwik_deliveryagentmastermr/quick_dashboard');
                  } else{
                    this.$fire({
                      text: result.body[0].returnvalue,
                      type: "error",
                      timer: 30000
                    }); 
                  }
                })
                .catch(ex => {
                  console.log("error", ex);
                });
          }
          else{
              document.getElementById("overlay").style.display = "block";
                const agnetsave = {
                  usertype:editusertype,
                  deliveryagentfirstname:this.customer.deliveryagentfirstname,
                  deliveryagentlastname:this.customer.deliveryagentlastname,
                  deliveryagentmobilenumber:this.customer.deliveryagentmobilenumber,
                  deliveryagentaltmobilenumber:this.customer.deliveryagentaltmobilenumber,
                  password:this.customer.password,
                  vehicleno:vehicleno1 ,
                  isactive:this.customer.isactive,
                  isverified:this.customer.isverified,
                  privilege_rider:this.customer.isprivilage,
                  lastmodifiedby:`${userInfo.sysemailid}`,
                  deliveryagentpincode:`${userInfo.pickuplocationpincode}`,
                  local:this.customer.local,
                  vehicleno_prefix:this.customer.vehicleprefix,
                  vehicle_country:this.customer.vehiclecountry,
                  vehicle_city:this.customer.vehiclecity,
                  driving_license:this.customer.drivinglicense,
                  contracter_emailid:this.customer.contracteremail,
                  driver_contracter_name:this.customer.drivercontractername,
                  is_dummy:this.customer.isdummy,
                  ivr_rider:this.isIVR,
                  is_sdd_ndd:this.customer.RiderFlag,
                  relieving_rider:this.customer.editfmridertype,
                  hub_to_hub_delivery:'No',
                  fuel_allowance : this.customer.fuel_allowance,
                  is_qwik_user: `${userInfo.is_qwik_user}`
                }
                console.log("agnetsave",agnetsave)
                // return false
                
                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentsignuphub`,agnetsave)
                .then(result => {
              // console.log(result);
                  document.getElementById("overlay").style.display = "none";
                  if (result.body[0].returnmsg === "Successful") {
                      this.$fire({
                        text: "Added successfully",
                        type: "success",
                        timer: 30000
                      }); 
                    this.customer = {};
                    this.$router.push('/qwik_deliveryagentmastermr/quick_dashboard');
                  } 
                  else{
                    this.$fire({
                      text: result.body[0].returnvalue,
                      type: "error",
                      timer: 30000
                    }); 
                  }
                })
                .catch(ex => {
                  console.log("error", ex);
                });
          }
      }
      else{
        if(editusertype=='3'){
          document.getElementById("overlay").style.display = "block";
          const agnetsave = {
                 usertype:editusertype,
                 deliveryagentfirstname:this.customer.deliveryagentfirstname,
                 deliveryagentlastname:this.customer.deliveryagentlastname,
                 deliveryagentmobilenumber:this.customer.deliveryagentmobilenumber,
                 deliveryagentaltmobilenumber:this.customer.deliveryagentaltmobilenumber,
                 password:this.customer.password,
                 vehicleno:vehicleno1 ,
                 isactive:this.customer.isactive,
                 isverified:this.customer.isverified,
                 privilege_rider:this.customer.isprivilage,
                 lastmodifiedby:`${userInfo.sysemailid}`,
                 deliveryagentpincode:`${userInfo.pickuplocationpincode}`,
                 local:this.customer.local,
                 vehicleno_prefix:this.customer.vehicleprefix,
                 vehicle_country:this.customer.vehiclecountry,
                 vehicle_city:this.customer.vehiclecity,
                 driving_license:this.customer.drivinglicense,
                 contracter_emailid:this.customer.contracteremail,
                 driver_contracter_name:this.customer.drivercontractername,
                 is_dummy:this.customer.isdummy,
                 ivr_rider:this.isIVR,
                 is_sdd_ndd:this.customer.RiderFlag,
                 hub_to_hub_delivery:this.customer.hubtohub,
                 fuel_allowance : this.customer.fuel_allowance,
                 is_qwik_user: `${userInfo.is_qwik_user}`
          }
          // console.log(" KSA else iffff",agnetsave);
          console.log("agnetsave",agnetsave)
              // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentsignuphub`,agnetsave)
            .then(result => {
             // console.log(result);
              document.getElementById("overlay").style.display = "none";
                if (result.body[0].returnmsg === "Successful") {
                    this.$fire({
                      text: "Added successfully",
                      type: "success",
                      timer: 30000
                    }); 
                    this.customer = {};
                    this.$router.push('/qwik_deliveryagentmastermr/quick_dashboard');
                  } 
                  else {
                    this.$fire({
                      text: result.body[0].returnvalue,
                      type: "error",
                      timer: 30000
                    });
                }
              })
              .catch(ex => {
                console.log("error", ex);
              });
        }
        else{
             document.getElementById("overlay").style.display = "block";
              const agnetsave = {
                 usertype:editusertype,
                 deliveryagentfirstname:this.customer.deliveryagentfirstname,
                 deliveryagentlastname:this.customer.deliveryagentlastname,
                 deliveryagentmobilenumber:this.customer.deliveryagentmobilenumber,
                 deliveryagentaltmobilenumber:this.customer.deliveryagentaltmobilenumber,
                 password:this.customer.password,
                 vehicleno:vehicleno1 ,
                 isactive:this.customer.isactive,
                 isverified:this.customer.isverified,
                 privilege_rider:this.customer.isprivilage,
                 lastmodifiedby:`${userInfo.sysemailid}`,
                 deliveryagentpincode:`${userInfo.pickuplocationpincode}`,
                 local:this.customer.local,
                 vehicleno_prefix:this.customer.vehicleprefix,
                 vehicle_country:this.customer.vehiclecountry,
                 vehicle_city:this.customer.vehiclecity,
                 driving_license:this.customer.drivinglicense,
                 contracter_emailid:this.customer.contracteremail,
                 driver_contracter_name:this.customer.drivercontractername,
                 is_dummy:this.customer.isdummy,
                 ivr_rider:this.isIVR,
                 is_sdd_ndd:this.customer.RiderFlag,
                 relieving_rider:this.customer.editfmridertype,
                 hub_to_hub_delivery: this.customer.hubtohub,
                 fuel_allowance : this.customer.fuel_allowance,
                 is_qwik_user: `${userInfo.is_qwik_user}`
              }
              console.log("agnetsave",agnetsave)
              // return false
              this.$http.post(`${CONSTANTS.MIGRATION_API_URL
                }/deliveryagentsignuphub`,agnetsave)
              .then(result => {
             // console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body[0].returnmsg === "Successful") {
                   this.$fire({
                      text: "Added successfully",
                      type: "success",
                      timer: 30000
                    }); 
                  this.customer = {};
                  this.$router.push('/qwik_deliveryagentmastermr/quick_dashboard');
                } else{
                    this.$fire({
                      text: result.body[0].returnvalue,
                      type: "error",
                      timer: 30000
                    }); 
                }
              })
              .catch(ex => {
                console.log("error", ex);
              });
        }
      }    
        
      } 
      else {
        this.$fire({
                  text: "Please Enter Valid Mobile Number",
                  type: "error",
                  timer: 30000
                }); 
      }
    },
     cancel:function() {
     
     // alert("hello");
    },
    
    
  },


};
</script>
<style>
.swal2-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
}
</style>
